import davocarLogoFooter from '@/images/clients/davocar-logo.jpg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const Davocar: IPartnerSettings = {
  partner: 'Davocar',
  hosts: [
    'davopojisteni.cz',
    // 'localhost:44470'
  ],
  logo: davocarLogoFooter,
  market: Market.CZ
}
